import React from 'react';
import logo from './../images/cpa-logo.png';
import bpointLogo from './../images/bpoint.png';
import cbaLogo from './../images/cba.jpg';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

function Logo(props){
    return(
      <img src={props.image} className={props.class} alt={props.alt} />
    );
  }

  export const Footer = () => {
    return (
        <div className="footer">
            <Typography variant="h5" gutterBottom>
                Supported By
            </Typography>
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
            >
                    
                    <Grid item xs={6}>
                        <Logo image={bpointLogo} class="logo" alt="Bpoint Logo"/>
                    </Grid>
                    <Grid item xs={6}>
                        <Logo image={cbaLogo} class="logo" alt="Commonwealth Bank Logo"/>
                    </Grid>
                    
                </Grid>
      </div>
    );
}